import { useState } from 'react'
import { MIN_MONTHLY_PAYMENT, MAX_MONTHLY_PAYMENT, DOWN_PAYMENT } from '../../../../constants/listings'
import { useSelector } from 'react-redux'
import { FormField } from '../../..'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { Box, Button, Card, CardBody, Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { formatCurrency } from '../../../../helpers/formatters'

import styles from '../Filters.module.scss'
import { HOME_SEARCH_LISTINGS_FILTER } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

const DEFAULT_DOWN_PAYMENT = 20000

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.monthly.payment.heading',
    defaultMessage: 'Monthly payment'
  },
  min: {
    id: 'General.minimum',
    defaultMessage: 'Minimum'
  },
  max: {
    id: 'General.maximum',
    defaultMessage: 'Maximum'
  },
  downPaymentHeader: {
    id: 'HomeSearch.listings.filters.monthly.payment.downpayment.heading',
    defaultMessage: 'Down payment'
  },
  downPaymentText: {
    id: 'HomeSearch.listings.filters.monthly.payment.downPayment.text',
    defaultMessage: 'Based on a {downPayment} down payment'
  },
  customizeHeader: {
    id: 'HomeSearch.listings.filters.monthly.payment.customize.header',
    defaultMessage: 'Customize'
  },
  customizeText: {
    id: 'HomeSearch.listings.filters.monthly.payment.customize.text',
    defaultMessage: 'Customize this'
  },
  updateText: {
    id: 'HomeSearch.listings.filters.monthly.payment.update.text',
    defaultMessage: 'Update this'
  },
  close: {
    id: 'General.close',
    defaultMessage: 'Close'
  }
})

export const MonthlyPayment = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const [downPayment, setDownPayment] = useState(filters[DOWN_PAYMENT] || DEFAULT_DOWN_PAYMENT)
  const [showDownPaymentInput, setShowDownPaymentInput] = useState(false)

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <div className={styles.rangeFields}>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Dollars
          className={styles.rangeField}
          name={MIN_MONTHLY_PAYMENT}
          defaultValue={filters[MIN_MONTHLY_PAYMENT] || null}
        >
          {intl.formatMessage(MSG.min)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Dollars>
        <div className={styles.dashMark}>—</div>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Dollars
          className={styles.rangeField}
          name={MAX_MONTHLY_PAYMENT}
          defaultValue={filters[MAX_MONTHLY_PAYMENT] || null}
        >
          {intl.formatMessage(MSG.max)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Dollars>
      </div>
      {!showDownPaymentInput && (
        <Flex flexDirection={['column', null, null, null, 'row']} justifyContent='left' alignItems='left' my={2}>
          <Text mb={0} mr={1} display='inline-block' size='sm'>
            {intl.formatMessage(MSG.downPaymentText, { downPayment: formatCurrency(downPayment) })}
          </Text>
          <Button
            alignSelf={['baseline', null, null, null, 'center']}
            size='sm'
            colorScheme='primary'
            variant='link'
            display='inline-block'
            tracking={{
              guid: 'ovpjGTehDXHrpGQ5Zysyf1',
              ui_context: HOME_SEARCH_LISTINGS_FILTER,
              descriptor: MSG.customizeText.defaultMessage
            }}
            onClick={() => setShowDownPaymentInput(true)}
          >
            {downPayment === DEFAULT_DOWN_PAYMENT
              ? intl.formatMessage(MSG.customizeText)
              : intl.formatMessage(MSG.updateText)}
          </Button>
        </Flex>
      )}
      <Card mt={2} display={!showDownPaymentInput ? 'none' : 'block'}>
        <CardBody>
          <Box display='flex'>
            <Heading size='sm' mb={1}>
              {intl.formatMessage(MSG.customizeHeader)}
            </Heading>
            <Button
              onClick={() => setShowDownPaymentInput(false)}
              variant='link'
              colorScheme='primary'
              size='sm'
              position='absolute'
              right='3'
              top='2'
              tracking={{
                guid: '47p4WpxN8c9epxxDaotGk8',
                ui_context: HOME_SEARCH_LISTINGS_FILTER,
                descriptor: MSG.close.defaultMessage
              }}
            >
              {intl.formatMessage(MSG.close)}
            </Button>
          </Box>
          {/* eslint-disable-next-line */}
            {/* @ts-ignore */}
          <FormField.Dollars
            name={DOWN_PAYMENT}
            value={downPayment}
            onChange={(e: { target: { value: any } }) => setDownPayment(e.target.value)}
          >
            {intl.formatMessage(MSG.downPaymentHeader)}
            {/* eslint-disable-next-line */}
              {/* @ts-ignore */}
          </FormField.Dollars>
        </CardBody>
      </Card>
    </FilterSection>
  )
}
